<template>
  <v-stepper v-model="step" vertical>
    <v-stepper-step :complete="step > 1" step="1" editable>
      Select an Broker
      <small>You need to create an account before connect to TradingIF.com</small>
    </v-stepper-step>
    <v-stepper-content step="1">
      <Brokers @selected-broker="onSelectedBroker" />
    </v-stepper-content>
    <v-stepper-step :complete="step > 2" step="2" editable>Instructions</v-stepper-step>
    <v-stepper-content step="2" editable>
      <CTRADER v-if="broker.type == 'ctrader'" @accounts="onAccounts"></CTRADER>
      <OANDA v-else-if="broker.type == 'oanda'" @accounts="onAccounts"></OANDA>
      <FXCM v-else-if="broker.type == 'fxcm'" @accounts="onAccounts" />
    </v-stepper-content>
    <v-stepper-step :complete="step > 3" step="3">Create Accounts</v-stepper-step>
    <v-stepper-content step="3" editable>
      <v-data-iterator
        :items="accounts"
        item-key="loginId"
        :items-per-page="10"
        hide-default-footer
      >
        <template v-slot:default="{ items }">
          <v-row>
            <v-col v-for="item in items" :key="item.name" cols="12" sm="6" md="4" lg="3">
              <CRUD :new-item="item" @closed="onClose"></CRUD>
            </v-col>
          </v-row>
        </template>
      </v-data-iterator>
    </v-stepper-content>
  </v-stepper>
</template>
<script>
import { ERROR } from "@/store/actions.type";
import Brokers from "@/components/brokers/Brokers.vue";
import OANDA from "@/components/accounts/Oanda.vue";
import FXCM from "@/components/accounts/Fxcm.vue";
import CTRADER from "@/components/accounts/Ctrader.vue";
import CRUD from "@/components/accounts/CRUD.vue";
export default {
  name: "NewAccountInSteps",
  components: {
    Brokers,
    CRUD,
    OANDA,
    FXCM,
    CTRADER
  },

  data() {
    return {
      step: 1,
      query: null,
      accounts: [],
      broker: {
        name: null,
        type: null
      },
      loading: false
    };
  },
  methods: {
    onSelectedBroker(broker) {
      this.accounts = []; //reset
      this.step = 2;
      this.broker.name = broker.name;
      this.broker.type = broker.type;
    },

    onAccounts(val) {
      this.accounts = val;
      this.step = 3;
      this.loading = !this.loading;
    },
    onClose(item) {
      for (var i = 0; i < this.accounts.length; i++) {
        if (this.accounts[i].loginId === item.loginId) {
          this.$store.dispatch(
            ERROR.PUSH,
            "Removed Account # " + this.accounts[i].name
          );
          this.accounts.splice(i, 1);
          i--;
        }
      }
    }
  }
};
</script>
<style>
</style>